export default __webpack_public_path__ + "static/media/profile10.ed1cb5bd.png";